import { EditButton, ShowButton } from "react-admin";
import { AppDeleteButton } from "./AppDeleteButton";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { colors, radius } from "../data/tokens";

// Botões de ação padrão (36×36) para linhas de listas react-admin —
// mesma métrica do ActionIconButton das telas Iugu, porém com os botões
// do react-admin por baixo (Editar navega; Excluir deleta com desfazer).
// Os cliques não disparam o rowClick da linha.
const actionSx = (variant: "default" | "danger") => ({
  minWidth: 36,
  width: 36,
  height: 36,
  padding: 0,
  borderRadius: `${radius.sm}px`,
  color: variant === "danger" ? colors.action : colors.primary,
  backgroundColor: variant === "danger" ? colors.actionSoft : colors.bgContent,
  "& .MuiButton-startIcon": { margin: 0 },
  "&:hover": {
    backgroundColor:
      variant === "danger" ? colors.actionSoft : colors.bgContent,
    filter: "brightness(0.94)",
  },
  "&.Mui-disabled": {
    opacity: 0.35,
    color: variant === "danger" ? colors.action : colors.primary,
    backgroundColor: colors.neutral100,
  },
});

// delDisabledReason: quando informado, o Excluir aparece desabilitado e o
// tooltip explica o motivo (ex.: regra de usuário em uso)
export function RaRowActions({
  edit = true,
  del = true,
  show = false,
  delDisabledReason,
}: {
  edit?: boolean;
  del?: boolean;
  show?: boolean;
  delDisabledReason?: string;
}) {
  return (
    <Box
      sx={{ display: "flex", gap: 0.75, justifyContent: "flex-end" }}
      onClick={(e) => e.stopPropagation()}
    >
      {show ? (
        <Tooltip title="Ver">
          <span>
            <ShowButton label="" sx={actionSx("default")} />
          </span>
        </Tooltip>
      ) : null}
      {edit ? (
        <Tooltip title="Editar">
          <span>
            <EditButton label="" sx={actionSx("default")} />
          </span>
        </Tooltip>
      ) : null}
      {del ? (
        <Tooltip title={delDisabledReason || "Excluir"}>
          <span>
            <AppDeleteButton
              label=""
              disabled={Boolean(delDisabledReason)}
              sx={actionSx("danger")}
            />
          </span>
        </Tooltip>
      ) : null}
    </Box>
  );
}
